import loadable from '@loadable/component';
import React from 'react';
import { IconBaseProps } from 'react-icons/lib';
import { iconNames } from './icon-names';

interface IProps extends IconBaseProps {
  name: (typeof iconNames)[number] | string;
}

const Icon: React.FC<IProps> = ({ name, ...rest }) => {
  const lib = name
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .split(' ')[0]
    .toLocaleLowerCase();

  if (!!lib === false) return <></>;

  const ElementIcon = loadable(() => import(`react-icons/${lib || 'hi'}/index.js`), {
    resolveComponent: (el: JSX.Element) => el[name as keyof JSX.Element],
  });

  return <ElementIcon {...rest} />;
};

export default Icon;
